import { createRouter, createWebHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import Register from '@/views/Register.vue';
import User from '@/views/User.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Dashboard from "@/views/Dashboard.vue";
import Project from "@/views/QrCode.vue";
import Order from "@/views/Order.vue";
import CreateProject from "@/views/CreateQrCode.vue";
import QrCodeProductAndName from "@/views/qr-code/QrCodeProductAndName.vue";
import QrCodeType from "@/views/qr-code/QrCodeType.vue";
import QrCodeDesign from "@/views/qr-code/QrCodeDesign.vue";
import QrCodeHomepage from "@/views/qr-code/QrCodeHomepage.vue";
import QrCodeOrder from "@/views/qr-code/QrCodeOrder.vue";
import { useUserStore } from "@/store/user.js";
import { storeToRefs } from "pinia";
import {useStatesStore} from "@/store/states.js";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { name: 'homepage', path: '/', component: Dashboard, meta: { auth: true } },

        { name: 'forgot-password', path: '/forgot-password', component: Login, meta: { auth: false } },
        { name: 'login', path: '/login', component: Login, meta: { auth: false } },
        { name: 'register', path: '/register', component: Register, meta: { auth: false } },
        { name: 'forgot-password', path: '/forgot-password', component: ForgotPassword, meta: { auth: false } },
        { name: 'reset-password', path: '/reset-password', component: ResetPassword, meta: { auth: false } },

        { name: 'dashboard', path: '/dashboard', component: Dashboard, meta: { auth: true } },
        { name: 'qr-code', path: '/qr-codes/:qrCode', component: Project, meta: { auth: true } },
        { name: 'order', path: '/qr-codes/:qrCode/order', component: Order, meta: { auth: true } },
        { name: 'user', path: '/user', component: User, meta: { auth: true } },

        {
            name: 'new-qr-code',
            path: '/create',
            component: CreateProject,
            meta: { auth: true },
            children: [
                { name: 'qr.create.product', path: 'product/:qrCode?', component: QrCodeProductAndName },
                { name: 'qr.create.type', path: 'type/:qrCode?', component: QrCodeType },
                { name: 'qr.create.homepage', path: 'homepage/:qrCode', component: QrCodeHomepage },
                { name: 'qr.create.design', path: 'design/:qrCode', component: QrCodeDesign },
                { name: 'qr.create.order', path: 'order/:qrCode', component: QrCodeOrder },
            ]
        },

    ]
})

router.beforeEach((to) => {
    const userStore = useUserStore();
    const { user } = storeToRefs(userStore);
    const statesStore = useStatesStore();
    statesStore.reset();

    if (to.matched.some(record => record.meta.auth && ! user.value)) {
        return {
            name: 'login',
            query: { redirect: to.fullPath }
        }
    }

    return true;
})

export default router
